module.exports = __webpack_public_path__ + "7e4b29ba/img/delete-icon.eb7de062.svg";